import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { JwtPayload } from 'jwt-decode';

@Injectable({
  providedIn: 'root',
})
export class JwtService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  /**
   * Decode JWT token safely for SSR
   * Only works on browser, returns null on server
   */
  async decodeToken<T extends JwtPayload>(token: string): Promise<T | null> {
    if (!isPlatformBrowser(this.platformId)) {
      return null;
    }

    try {
      // Dynamic import to avoid SSR issues
      const { jwtDecode } = await import('jwt-decode');
      return jwtDecode<T>(token);
    } catch (error) {
      console.error('Error decoding JWT token:', error);
      return null;
    }
  }

  /**
   * Check if we're in a browser environment
   */
  isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }
}
